<template>
	<div class="myOrder layui-layout layui-layout-admin" style="background:#fff;">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				我的订单
			</div>
		</div>
		<div class="sxBox">
			<div class="layui-form f_row al_itm">
				<select name="city" lay-filter="status" id="select">
					<option value="">订单状态</option>
					<option :value="item.id" v-for="(item,i) in clasList" :key="i">{{item.title}}</option>
				</select>
				<div class="layui-inline f_row al_itm margin_l20">
					<div class="layui-input-inline" style="width: 100px;">
						<input type="text" class="layui-input" id="times1" readonly placeholder="开始日期">
					</div>
					<div class="layui-form-mid" style="margin: 0 10px;">-</div>
					<div class="layui-input-inline" style="width: 100px;">
						<input type="text" class="layui-input" id="times2" readonly placeholder="结束日期">
					</div>
				</div>
				<button type="button" class="layui-btn zt_color margin_l20" @click="onSearch">搜索</button>
				<button type="button" class="layui-btn zt_color margin_l20" @click="onReset">重置</button>
			</div>
		</div>
		<div>
			<table class="layui-table align_center" id="orders" style="width:90%;margin:0 5%;">
				<colgroup>
					<col width="100">
					<col width="120">
					<col width="150">
					<col>
					<col>
					<col>
					<col>
					<col width="120">
					<col width="150">
				</colgroup>
				<thead>
					<tr>
						<th class="align_center">序号</th>
						<th class="align_center">客户编号</th>
						<th class="align_center">订单编号</th>
						<th class="align_center">资料交期</th>
						<th class="align_center">客户下单时间</th>
						<th class="align_center">资料是否需要确认</th>
						<th class="align_center">客户确认状态</th>
						<th class="align_center">订单交付类型</th>
						<th class="align_center">订单状态</th>
						<th class="align_center">订单操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,i) in datas" :key="i">
						<td>{{i+1}}</td>
						<td>{{item.company_id}}</td>
						<td>{{item.order_num}}</td>
						<td>{{item.antipate}}</td>
						<td>{{item.createtime_text}}</td>
						<td>{{item.handle_demand == 1 ? '需要' : '不需要'}}</td>
						<td v-if='item.is_c_confirm == 0' class="color1">未上传</td>
						<td v-if='item.is_c_confirm == 1' class="color1">待确认</td>
						<td v-if='item.is_c_confirm == 2' class="color1">已确认</td>
						<td v-if='item.is_c_confirm == 3' class="color1">未通过</td>
						<td :class="item.is_fast_text == '普通件' ? '' : 'jiaji'">{{item.is_fast_text}}</td>
						<td :class="item.status == 6 ||item.status == 7 ||item.status == 10 || item.status == 11 ? 'color1' : ''">{{item.status == 6 ||item.status == 7 ||item.status == 10 || item.status == 11 ? '已完成' : '进行中'}}</td>
						<td>
							<button @click="showDetails(item.order_num)" type="button" class="layui-btn zt_color">详情</button>
						</td>
					</tr>
					<tr v-if="datas.length == 0">
						<td style="padding: 5px 30px 0;text-align: center;line-height: 50px;" colspan="10">暂无数据</td>
					</tr>
				</tbody>
			</table>
			<div id="lypages" style="margin-left: 5%;"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'myOrder',
		data() {
			return {
				dscModel: false,
				showClass: 1,
				tables: '',
				forms: '',
				nowTimes: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
				value: '',
				value2: '',
				status: '',
				clasList: [{
						title: '进行中',
						id: 1
					},
					{
						title: '已完成',
						id: 2
					}
				],
				datas: [],
				pages: 1,
				limit: 10,
				count: 1,
				search: 0,
			}
		},
		created() {
			this.getData();
		},
		mounted() {
			let _this = this;
			layui.use(['table', 'form', 'laydate'], () => {
				this.tables = layui.table;
				this.forms = layui.form;
				var laydate = layui.laydate;
				this.forms.render('select');
				this.forms.on('select(status)', function(data) {
					_this.status = data.value;
				});
				laydate.render({
					elem: '#times1', //指定元素
					theme: '#4876FF',
					max: this.nowTimes,
					done: function(value, date, endDate) {
						let time = new Date(value);
						let y = time.getFullYear();
						let m = time.getMonth() + 1;
						let d = time.getDate();
						let start = new Date(y + '/' + m + '/' + d);
						_this.value = new Date(start).getTime() / 1000;
					}
				});
				laydate.render({
					elem: '#times2', //指定元素 
					theme: '#4876FF',
					max: this.nowTimes,
					done: function(value, date, endDate) {
						let time = new Date(value);
						let y = time.getFullYear();
						let m = time.getMonth() + 1;
						let d = time.getDate();
						let end = new Date(y + '/' + m + '/' + d);
						_this.value2 = new Date(end).getTime() / 1000 + 86399;
					}
				});
			});
		},
		methods: {
			getData() {
				let _this = this;
				layui.use(['laypage'], () => {
					var laypage = layui.laypage;
					var obj = {
						token: _this.getCookie('token'),
						page: _this.pages,
						limit: _this.limit
					}
					if(this.search == 1) {
						let value = _this.value;
						let value2 = _this.value2;
						if(value && value2) {
							let val = value2;
							if(value > value2) {
								value2 = value;
								value = val;
							}
						}
						obj.start_time = value;
						obj.end_time = value2;
						obj.status = _this.status;
					}
					api.OrderList(obj).then((res) => {
						if(res.code == 1) {
							for(let i = 0; i < res.data.list.length; i++) {
								res.data.list[i].antipate = _this.getTimes2(res.data.list[i].createtime + 60 * 30);
							}
							_this.datas = res.data.list;
							_this.count = res.data.count;
						} else {
							_this.datas = [];
						}
						laypage.render({
							elem: 'lypages',
							theme: '#4876FF',
							curr: _this.pages,
							count: _this.count,
							limit: 10,
							jump: function(obj, first) {
								if(!first) {
									_this.pages = obj.curr;
									_this.getData();
								}
							}
						});
					})
				})
			},
			onSearch() {
				this.search = 1;
				this.pages = 1;
				this.count = 1;
				this.getData();
			},
			onReset() {
				this.search = 0;
				this.pages = 1;
				$('#select').val('');
				$('#times1').val('');
				$('#times2').val('');
				this.getData();
				this.forms.render('select');
			},
			showDetails(num) {
				this.$router.push({
					path: '/orderDetail',
					query: {
						id: num
					}
				})
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.jiaji {
		color: rgba(229, 28, 35, 1);
	}
	
	.myOrder {
		font-family: SourceHanSansSC;
	}
	
	.sxBox {
		padding: 20px 5% 10px;
	}
	
	.color1 {
		color: rgb(72, 118, 255);
	}
</style>


// WEBPACK FOOTER //
// src/components/myOrder.vue